import { generateUUID } from "syf-js-utilities";
/**
 * Get's the sessionStorage's "correlationId" or creates & sets it if not already there via `generateUUID`.
 * @returns string correlationId from the session storage
 */
var getCorrelationId = function () {
    var correlationId = sessionStorage.getItem("correlationId");
    if (!correlationId) {
        correlationId = generateUUID();
        sessionStorage.setItem("correlationId", correlationId);
    }
    return correlationId;
};
export default getCorrelationId;
//# sourceMappingURL=getCorrelationId.js.map